export const GET_UNIT_LI = 'GET_UNIT_LI';
export const GET_UNIT_LI_COUNT = 'GET_UNIT_LI_COUNT';
export const GET_UNIT_LI_PAGE = 'GET_UNIT_LI_PAGE';
export const GET_UNIT_LI_PAGE_DATA = 'GET_UNIT_LI_PAGE_DATA';

export const GET_UNIT = 'GET_UNIT';
export const GET_UNIT_SLUG_CONDITION = 'GET_UNIT_SLUG_CONDITION';
export const GET_UNIT_DATA = 'GET_UNIT_DATA';
export const NEW_UNIT_INIT = 'NEW_UNIT_INIT';
export const SAVE_UNIT = 'SAVE_UNIT';
export const SAVE_UNIT_DATA = 'SAVE_UNIT_DATA';
export const DELETE_UNIT = 'DELETE_UNIT';
export const UNIT_SCAN_IND_SET = 'UNIT_SCAN_IND_SET';

export const API_ERROR = 'API_ERROR';

export const GET_GROUP = 'GET_GROUP';
export const GET_GROUP_DATA = 'GET_GROUP_DATA';
export const NEW_GROUP_INIT = 'NEW_GROUP_INIT';
export const GET_GROUP_UTYPE_UNIT_LI = 'GET_GROUP_UTYPE_UNIT_LI';
export const GET_GROUP_UTYPE_UNIT_LI_DATA = 'GET_GROUP_UTYPE_UNIT_LI_DATA';
export const DELETE_GROUP = 'DELETE_GROUP';
export const SAVE_GROUP = 'SAVE_GROUP';
export const SAVE_GROUP_DATA = 'SAVE_GROUP_DATA';

export const GET_GROUP_LI = 'GET_GROUP_LI';
export const GET_GROUP_LI_DATA = 'GET_GROUP_LI_DATA';

export const GET_SER = 'GET_SER';
export const GET_SER_DATA = 'GET_SER_DATA';
export const NEW_SER_INIT = 'NEW_SER_INIT';
export const DELETE_SER = 'DELETE_SER';
export const SAVE_SER = 'SAVE_SER';
export const SAVE_SER_DATA = 'SAVE_SER_DATA';

export const GET_SER_LI = 'GET_SER_LI';
export const GET_SER_LI_DATA = 'GET_SER_LI_DATA';

export const GET_USER = 'GET_USER';
export const GET_USER_DATA = 'GET_USER_DATA';
export const NEW_USER_INIT = 'NEW_USER_INIT';
export const DELETE_USER = 'DELETE_USER';
export const SAVE_USER = 'SAVE_USER';
export const SAVE_USER_DATA = 'SAVE_USER_DATA';

export const GET_USER_LI = 'GET_USER_LI';
export const GET_USER_LI_DATA = 'GET_USER_LI_DATA';

export const AUTH_CH = 'AUTH_CH';
export const AUTH_CH_DATA = 'AUTH_CH_DATA';
export const AUTH_SET = 'AUTH_SET';
export const AUTH_LOUT = 'AUTH_LOUT';



